import { observable } from "mobx";
import AgendamentoContainerService from "../../../../../services/AgendamentoContainerService";

export default class RetiradaDevolucaoStore {



    @observable tiposCntr;
    @observable listaArmadores;
    @observable listaOperacoes;
    @observable cnpjParceiro;

    constructor() {
        this.tiposCntr = [];
        this.listaArmadores = [];
        this.listaOperacoes = [];
        this.cnpjParceiro = [];

        this.atualizaDados = true;
        this.service = new AgendamentoContainerService();
        this.carregarTudo();
    };


    carregarTudo = () => {
        this.carregarTiposCntr();
        // this.carregarOperacoes();
        this.carregarArmadores();
        this.cnpjParceiro.push('');
    }

    carregarTiposCntr = () => {
        this.service.listarIsoDesistencia()
            .then(res => {
                if(res && res.data) {
                    this.tiposCntr = res.data;
                } else {
                    // mensagem de erro
                }
            })
            .catch(err => {
                console.error(err);
            });
    }
        
    carregarOperacoes = () => {
        this.service.listarOperacaoDesistencia()
            .then(res => {
                if(res && res.data) {
                    console.log(res.data);
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    carregarArmadores = () => {
        this.service.listarArmadoresDesistencia()
            .then(res => {
                if(res && res.data) {
                    this.listaArmadores = res.data;
                } else {
                    // mensagem de erro
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    adicionarNovoParceiro = () => {
        this.cnpjParceiro.push('');
    }

    removerParceiro = (index) => {
        this.cnpjParceiro = [...this.cnpjParceiro.slice(0, index), ...this.cnpjParceiro.slice(index + 1)];
    }

    carregarCnpjParceiro = (cnpj, index) => {
        if(cnpj === '') {
            this.cnpjParceiro[index] = '';
            return;
        } 
        this.service.carregarCnpjDesistencia(cnpj)
            .then(res => {
                if(res && res.data) {
                    this.cnpjParceiro[index] = res.data.Razao;
                } else {
                    // mensagem de erro
                    this.cnpjParceiro[index] = 'Não encontrado';
                }
            })
            .catch(err => {console.log(err)});
    }

}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/retirada-containers-devolucao/stores/RetiradaDepotDevolucaoStore.js